$.fn.FileInput = function() {
  let self = this
  self.fileNames = []
  self.currentFileList = self.get(0).files;
  self.totalSize = 0
  self.closest('.field--type-file').wrap('<div class="input-file-wrapper"></div>')
  self.wrapper = self.closest('.input-file-wrapper')
  self.wrapper.append('<div class="input-file-wrapper__documents" aria-hidden="true"><span>' + get_l10n().NO_FILE_SELECTED + '<span></div>')
  self.documents = self.wrapper.find('.input-file-wrapper__documents')
  self.wrapper.append('<div class="input-file-wrapper__total-size">' + get_l10n().TOTAL_WEIGHT + ': 0 MB</div>')
  self.totalSize_el = self.wrapper.find('.input-file-wrapper__total-size')
  if (self.attr('multiple')) {
    self.wrapper.addClass('--multiple')
  }

  self.changeFile = function() {
    if (self.get(0).files.length) {
      if (self.attr('multiple')) {
        const dataTransfer = new DataTransfer();
        for (let i = 0; i < self.currentFileList.length; i++) {
          dataTransfer.items.add(self.currentFileList[i]);
        }
        for (let i = 0; i < self.get(0).files.length; i++) {
          var is_duplicate = false;
          for (let x = 0; x < self.currentFileList.length; x++) {
            if (self.currentFileList[x].name == self.get(0).files[i].name && self.currentFileList[x].size == self.get(0).files[i].size) {
              is_duplicate = true;
            }
          }
          if (!is_duplicate) {
            dataTransfer.items.add(self.get(0).files[i]);
          }
        }
        self.get(0).files = dataTransfer.files;
      }
    }
    self.refresh_filelist()
  }

  self.refresh_filelist = function () {
    if (self.get(0).files.length < 1) {
      self.documents.closest('.field-container').find('.field').removeClass('field--populated')
      self.documents.attr('aria-hidden', 'true').html('<span>' + get_l10n().NO_FILE_SELECTED + '</span>');
      self.totalSize_el.hide()
      return false;
    }

    self.fileNames = []
    self.totalSize = 0
    for (let i = 0; i < self.get(0).files.length; i++) {
      self.fileNames.push(self.get(0).files[i].name);
      self.totalSize += self.get(0).files[i].size;
    }
    self.documents.closest('.field-container').find('.field').addClass('field--populated')
    var file_list = '';
    $.each(self.fileNames, function(index, fileName) {
      file_list += '<div class="input-file-wrapper__documents__item">' + fileName + '<i class="icon-close" data-index="' + index + '"></i></div>'
    });
    self.documents.attr('aria-hidden', 'false').html(file_list);
    self.documents.find('.icon-close').click(function() {
      self.removeFile($(this))
    })
    self.totalSize_el.show().html(get_l10n().TOTAL_WEIGHT + ': ' + Math.ceil(self.totalSize / 1024 / 1024) + 'MB');
    self.currentFileList = self.get(0).files
  }

  self.removeFile = function(file_to_remove) {
    const dataTransfer = new DataTransfer();
    self.fileNames.forEach((file, index) => {
      if (index !== file_to_remove.data('index')) {
        dataTransfer.items.add(self.get(0).files[index]);
      }
    });
    self.get(0).files = dataTransfer.files;
    self.trigger('change');
    self.refresh_filelist();
  }

  return function() {
    self.get(0).addEventListener('change', self.changeFile)
    return self
  }()
}
